<template lang='pug'>
    #suggest-bank-card-conciliation
        .ma-4
            v-btn( @click='fetch' ) refrescar conciliaciones&nbsp;
                v-icon refresh 
        template( v-for='suggest in suggests' )
            r-table(
                card
                class='ma-4'
                no-actions
                no-filter
                no-data-text='Sin datos'
                no-search
                no-helper
                no-export
                no-refresh
                no-pagination
                checkable
                :toolbar-title='"Glosa: " + suggest.bank_card.accounting_bank_card_movement_detail.movement_detail'
                toolbar-color='primary'
                toolbar-dark
                toolbar-dense
                v-bind='tableProps'
                v-model='suggest.items'
            )
                template( slot='items' )
                    v-btn( 
                        color='success' 
                        :disabled='! suggest.account_to_conciliate' 
                        @click='submit(suggest)'
                    ) conciliar &nbsp;
                        v-icon check_circle
</template>

<script>
//
import { mapActions } from 'vuex'
import { RBtnAction, RTable } from '@/components/reusable_components/next'
import AccountModel from '@/models/Accounting/AccAccount'
import BankCardConciliationModel from '@/models/Accounting/AccBankCardConciliation'
import BankCardConciliationSuggestHeaders from '@/views/Accounting/AccBankCardConciliation/AccBankCardConciliationSuggestHeaders'
//
export default {
    name: 'suggest-bank-conciliation',
    components: {
        RBtnAction,
        RTable,
    },
    computed: {
        tableProps() {
            return {
                headers: BankCardConciliationSuggestHeaders,
            }
        },
    },
    data() {
        return {
            suggests: [],
        }
    },
    methods: {
        error() {
            this.showErrorSnackbar('Error al conciliar asiento.')
        },
        fetch() {
            return BankCardConciliationModel
            .find('suggest')
            .then(this.setData)
        },
        fetchAccounts(item) {
            return AccountModel
                .where('acc_account_type_id', item.acc_account_type_id)
                .limit(-1)
                .get()
        },
        mapSuggest(item, idx) {

            //
            this.fetchAccounts(item.bank_card_account).then(this.setDataById(item))

            //
            item.items = [
                {
                    id: 1,
                    date: item.bank_card.bank_card_date,
                    account: item.bank_card_account,
                    amount_deb: item.is_debit ? item.bank_card.amount : 0,
                    amount_crd: item.is_debit ? 0 : item.bank_card.amount,
                    accounts: [],
                },
                {
                    id: 2,
                    date: item.account_to_conciliate ? item.account_to_conciliate.accounting_date : null,
                    account: item.account_to_conciliate,
                    amount_deb: item.is_debit ? 0 : item.bank_card.amount,
                    amount_crd: item.is_debit ? item.bank_card.amount : 0,
                    accounts: [],
                },
            ]
            
            //
            return item
        },
        setData(res) {
            this.suggests = Object.values(res).slice(0, -1).map(this.mapSuggest)
        },
        setDataById: item => res => {
            item.items[0].accounts = res.data
            item.items[1].accounts = res.data
        },
        showSuccess(){
            this.showSuccessSnackbar('Asiento conciliado exitosamente.')
        },
        submit(data) {
            BankCardConciliationModel
                .conciliate()
                .attach({
                    "bank_card_id" : data.bank_card_id,
                    "bank_card_account_id" : data.items[0].account.id,
                    "account_to_conciliate_seat_id" : data.account_to_conciliate.acc_accounting_seat_id,
                    "account_to_conciliate_account_id" : data.items[1].account.id,
                })
                .then(this.showSuccess)
                .then(this.fetch)
                .catch(this.error)
        },
    },
    mounted() {
        this.fetch()
    },
    beforeMount() {
        this.setTitle('Conciliación bancaria')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_ACCOUNT_BANK_CONCILIATION'))
                ctx.$router.push('/')
        })
    },
}
</script>
